module.exports = __webpack_public_path__ + "img/print-icon.b2338d49.svg";